import React from "react";
import { useSelector } from "react-redux";

const PROJECT_DOT_CLASSES = [
  "dashboard-widget-project-dot",
  "dashboard-widget-project-dot dashboard-widget-project-dot--alt-1",
  "dashboard-widget-project-dot dashboard-widget-project-dot--alt-2",
  "dashboard-widget-project-dot dashboard-widget-project-dot--alt-3",
];

const ProjectTimeSpent = () => {
  const { projects } = useSelector((state) => state.project);
  const list = (projects || []).slice(0, 8);
  const total = projects?.length ?? 0;

  return (
    <section className="dashboard-projects-section" aria-label="Projects">
      <div className="dashboard-projects-section-header">
        <h2 className="dashboard-projects-section-title">Projects</h2>
        <span className="dashboard-projects-section-hint">Live while you are on the dashboard</span>
      </div>
      <div className="dashboard-widget dashboard-widget--projects">
        <div className="dashboard-widget-header">
          <div className="dashboard-widget-header-left">
            <span className="dashboard-widget-icon-wrap">
              <img src="/svg/Icons/project-icon.svg" alt="" aria-hidden="true" />
            </span>
            <h3 className="dashboard-widget-title">Active projects</h3>
          </div>
          {total > 0 ? <span className="dashboard-widget-count">{total}</span> : null}
        </div>
        <div className="dashboard-widget-body">
          {total === 0 ? (
            <div className="dashboard-widget-empty">
              <span className="dashboard-widget-empty-icon dashboard-widget-empty-icon--projects" aria-hidden="true">
                📁
              </span>
              <p className="dashboard-widget-empty-text">No projects loaded yet</p>
              <p className="dashboard-widget-empty-hint">Projects will appear here once assigned</p>
            </div>
          ) : (
            <>
              <p className="dashboard-widget-summary">
                <strong>{total}</strong> active project{total !== 1 ? "s" : ""} · showing {list.length}
              </p>
              <ul className="dashboard-widget-list dashboard-projects-list">
                {list.map((p, index) => (
                  <li
                    key={p.projectId}
                    className="dashboard-widget-list-item dashboard-widget-list-item--plain"
                  >
                    <span
                      className={PROJECT_DOT_CLASSES[index % PROJECT_DOT_CLASSES.length]}
                      aria-hidden="true"
                    />
                    <span className="dashboard-widget-item-name">
                      {p.projectName || `Project #${p.projectId}`}
                    </span>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectTimeSpent;
